export default __webpack_public_path__ + "static/media/300x50Banner1.ced183ab.jpeg";